import { Injectable } from "@angular/core"
import * as jwt_decode from "jwt-decode"

import { environment } from "../../../environments/environment"
import { StorageService } from "../storage.service";
export let isDebugMode = environment.isDebugMode

@Injectable()
export class JwtTokenService {

    constructor(private storageService: StorageService) { }

    getToken() {
        isDebugMode ? console.log(`getToken()`) : undefined
        let token = this.storageService.get("apiToken")
        if (!this.getDecodedAccessToken(token)) {
            token = null
            this.removeToken()
        }
        return token
    }

    setToken(value) {
        isDebugMode ? console.log(`setToken()`) : undefined
        value ? this.storageService.set("apiToken", value) : this.storageService.remove("apiToken")
    }

    removeToken() {
        isDebugMode ? console.log(`removeToken()`) : undefined
        this.storageService.remove("apiToken")
    }

    getDecodedAccessToken(token: string): boolean {
        isDebugMode ? console.log(`getDecodedAccessToken()`) : undefined
        try {
            jwt_decode(token)
            return true
        } catch (Error) {
            return false
        }
    }



}